import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { IConfigService } from '../../configuration/services/config.service';
import { ILoggingService } from '../../logging/logging.service';
import { IBaseService } from '../../services/misc/base.service';
import { IRoutingService } from '../../services/misc/routing.service';

export interface IAppPage {

    icon?: string;
    title?: string;
    url?: string;
    method?: () => Promise<void>;

}

export interface IApplicationService extends IBaseService {

    appPages?: IAppPage[];
    applicationTitle?: string;
    isBusy: boolean;
    isBusy$: Observable<boolean>;
    isBusySubject: BehaviorSubject<boolean>
    headerCaption?: string;
    selectedPage?: IAppPage;

    getConfigurationService(): IConfigService;
    getLoggingService(): ILoggingService;
    getRoutingService(): IRoutingService;
    initializeAsync(): Promise<void>;
    navigateToAsync(path: string, params?: any): Promise<void>
    navigateToAppPageAsymc(appPage: IAppPage): Promise<void>;
    parseError(error: any): string;
    setIsBusyAsync(value: boolean, text?: string): Promise<void>;
    setPagesAsync(): Promise<void>;
    showErrorAsync(errorMessages: string[]): Promise<void>;
    subscribeForBusyChange(method: (value: boolean) => void): Subscription;
    waitAsync(value: number): Promise<void>;

}
